var lib_core = require("lib-core");
var cio_datamodel  = require("cio-datamodel");

var PolyLineToolModel = function (options) {
    lib_core.Model.apply(this, arguments);
    var self = this;

    this.mode = this.value("mode", true);
    this.mode(options.stateMachineMode || cio_datamodel.PolyPointMode.STRAIGHT);
    this.reverseSweep = 1; // 0=normal, 1=reversed logic
    this.useAxis = 1; // 1 = automatic mode, 0 = opposite of auto mode

    // tool options
    this.toolOptionsVisible = this.value("toolOptionsVisible", true);
};

lib_core.inherit(PolyLineToolModel, lib_core.Model);
PolyLineToolModel.$class = "PolyLineToolModel";
module.exports = PolyLineToolModel;
